<app-toolbar id="kt_app_toolbar" class="app-toolbar py-lg-6"></app-toolbar>

<div class="card rounded-2">
	<div class="card-body bg-gray-200 p-4">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<li class="nav-item">
				<a class="nav-link"
				   routerLink="deposits"
				   routerLinkActive="active"
				   [routerLinkActiveOptions]="{exact: false}">
					Manage Deposits
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link"
				   routerLink="credit-debit-notes"
				   routerLinkActive="active"
				   [routerLinkActiveOptions]="{exact: false}">
					Manage Cr/Dr Notes
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link"
				   routerLink="allocation"
				   routerLinkActive="active"
				   [routerLinkActiveOptions]="{exact: false}">
					Allocation
				</a>
			</li>
		</ul>

		<!-- Router outlet for child components -->
		<router-outlet></router-outlet>
	</div>
</div>

<app-export-modal></app-export-modal>
